// extracted by mini-css-extract-plugin
export default {"root":"_2qWHA","cover":"_2u4R-","middle":"_2pNG6","sfwbrowse":"_2IwoZ","underlay":"miOrm"};